import React from "react";
import { Container, Row, Col } from "shards-react";

import ViewBatchReport from "../components/batch-report/ViewBatchReport";

class BatchReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <ViewBatchReport
             projectId={this.props.match.params.id}
             viewprops={this.props}
             />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default BatchReport;
